import React, { Component } from 'react'
import loadable from '@loadable/component'

// import { webTdk } from 'multiPublic/index'

const Mprank = loadable(() => import('../containers/Mprank'))

export default class MprankPage extends Component {
    static async getInitialProps (store) {
        let tdk = {
            title: '火星财经 专栏影响力榜单-火星财经'
        }
        return {
            clientLink: 'onlyPc',
            ...tdk
        }
    }

    render () {
        return <Mprank {...this.props}/>
    }
}
